import React, { FunctionComponent } from 'react'
import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'
type MagnifyingGlassIconProps = {
  width?: number
  height?: number
  includeBackground?: boolean
}

export const MagnifyingGlassIcon: FunctionComponent<MagnifyingGlassIconProps> = ({
  width = 64,
  height = 65,
  includeBackground = true,
}) => (
  <Svg width={width} height={height} viewBox='0 0 64 65' fill='none'>
    <G clipPath='url(#clip0_3157_40201)'>
      {includeBackground && (
        <>
          <Path
            d='M32.202 1.182c-4.418 0-8.704.757-12.74 2.25C9.854 6.995 3.1 14.89.93 25.096c-1.434 6.653-1.25 12.808.564 18.805 2.317 7.659 8.004 14.118 15.604 17.72 3.773 1.792 8.107 2.815 12.88 3.04.613.028 1.237.043 1.857.043 3.829 0 7.681-.525 11.45-1.56.29-.072.566-.146.856-.232 3.387-.992 6.435-2.56 9.043-4.656 2.832-2.262 5.163-5.13 6.92-8.52a35 35 0 001.044-2.212c2.01-4.67 2.982-9.896 2.81-15.122-.08-2.31-.425-4.767-1.02-7.306-.978-4.12-2.574-7.996-4.615-11.213a31.153 31.153 0 00-1.581-2.242c-3.67-4.733-9.386-8.054-16.526-9.6a37.858 37.858 0 00-8.012-.857l-.002-.001z'
            fill='#fff'
          />
          <Path
            d='M61.211 32.487c-.078-2.215-.417-4.509-.95-6.79-.874-3.673-2.308-7.295-4.274-10.396a28.537 28.537 0 00-1.433-2.033c-3.688-4.755-9.277-7.4-14.997-8.639-6.372-1.381-13.147-.978-19.272 1.29-8.86 3.283-14.893 10.476-16.861 19.727-.756 3.505-.978 7.466-.639 11.271H2.76c.196 2.163.587 4.274 1.172 6.215 2.177 7.192 7.466 12.9 14.203 16.092 3.649 1.733 7.726 2.593 11.87 2.789 4.235.196 8.535-.34 12.51-1.433.26-.065.508-.13.769-.209 3.113-.912 5.824-2.32 8.143-4.182 2.528-2.02 4.612-4.56 6.229-7.675.351-.677.664-1.354.963-2.046 1.903-4.417 2.75-9.212 2.58-13.967l.013-.013v-.001z'
            fill='#FFE9E3'
          />
        </>
      )}
      <Path
        d='M24.402 41.657c.418-.807.944-1.557 1.407-2.34.1-.165.097-.166-.062-.294-5.063-3.76-7.277-10.746-5.181-16.689 2.765-8.566 13.19-12.795 21.179-8.545 8.564 4.28 10.862 15.936 4.493 23.077-3.96 4.67-10.882 6.461-16.62 4.259-.283-.104-.567-.202-.84-.331-.168-.08-.19-.069-.293.096-.47.709-.85 1.49-1.376 2.156a8.67 8.67 0 00-2.707-1.39z'
        fill='#85CCD5'
      />
      <Path
        d='M34.856 38.748c6.483 0 11.739-5.225 11.739-11.67s-5.256-11.67-11.739-11.67c-6.483 0-11.739 5.225-11.739 11.67s5.256 11.67 11.739 11.67z'
        fill='#E7F8F8'
      />
      <Path
        d='M28.607 29.154c-.611-1.158-1.162-2.415-1.129-3.748.004-2.232 2.066-4.196 4.334-3.638 1.223.339 2.295 1.037 3.238 1.869.193.166.198.166.375-.023 1.048-1.082 2.419-2.111 3.997-2.086 2.212.112 4.005 2.504 3.327 4.64-1.197 3.708-4.464 6.456-7.656 8.51-.583.335-1.224-.203-1.734-.467-1.956-1.282-3.542-3.073-4.752-5.057z'
        fill='#F69170'
      />
      <Path
        d='M24.332 41.393c.288.03.572.133.842.243 1.162.516 2.822 1.253 2.27 2.64-.155.423-.405.843-.64 1.238-1.342 2.182-2.59 4.421-3.983 6.573-.179.268-.364.532-.56.79-.373.501-.868.985-1.53.931-.763-.04-1.626-.599-2.27-1.12-.243-.2-.484-.42-.652-.684-.21-.327-.238-.706-.112-1.081.086-.265.222-.514.357-.763.46-.83.937-1.65 1.425-2.465 1.126-1.856 2.112-3.816 3.459-5.526a2.96 2.96 0 01.47-.49c.277-.217.586-.32.92-.286h.005z'
        fill='#976C4A'
      />
    </G>
    <Defs>
      <ClipPath id='clip0_3157_40201'>
        <Path fill='#fff' transform='translate(0 .966)' d='M0 0H64V64H0z' />
      </ClipPath>
    </Defs>
  </Svg>
)
